import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import BlockModel from "../../models/masters/block-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/Block/GetAllBlock";// //{/api/Block/GetAllBlock}`)  //// "https://localhost:7054/api/Block/GetAllBlock";
export const useGetBlock = createQuery<
BlockModel[],
  null,
  AxiosError
>({
  queryKey: ["keyBlocklist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
